var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronsLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 12L11.7 7.7C12.1 7.3 12.1 6.7 11.7 6.3C11.3 5.9 10.7 5.9 10.3 6.3L5.3 11.3C4.9 11.7 4.9 12.3 5.3 12.7L10.3 17.7C10.5 17.9 10.8 18 11 18C11.2 18 11.5 17.9 11.7 17.7C12.1 17.3 12.1 16.7 11.7 16.3L7.4 12ZM14.4 12L18.7 7.7C19.1 7.3 19.1 6.7 18.7 6.3C18.3 5.9 17.7 5.9 17.3 6.3L12.3 11.3C11.9 11.7 11.9 12.3 12.3 12.7L17.3 17.7C17.5 17.9 17.8 18 18 18C18.2 18 18.5 17.9 18.7 17.7C19.1 17.3 19.1 16.7 18.7 16.3L14.4 12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronsLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronsLeft.92f42390e57c00d155b6e174fdc22c35.svg";